export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardSales.vue?vue&type=style&index=0&id=1a83f66e&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardSales.vue?vue&type=style&index=0&id=1a83f66e&prod&scoped=true&lang=css&
// module id = 973
// module chunks = 0